import React from 'react';
import Helper from '../../helper';

const ResponsiveGif = () => {
  const userInfo = Helper();

  return (
    <div className={`w-screen relative mt-[-2px] left-1/2 right-1/2 -mx-[50vw] overflow-hidden ${userInfo ? 'hidden' : 'block'}`}>
      <div className="flex flex-col items-center justify-center w-full">
        {/* Desktop container for fixed size */}
        <div className="w-full flex flex-col md:flex-row md:gap-2 items-center justify-center md:w-[937px] md:h-[160px]">
          {/* First GIF */}
          <div className="relative w-full md:w-1/2 h-[64px] md:h-[160px] md:ml-2">
            <img
              src="https://images.staticcontent.io/rde/login/RDGIF-1.gif"
              alt="First GIF"
              className="w-full h-full object-cover"
            />
          </div>
          <div className=""></div>
          {/* Second GIF */}
          <div className="relative w-full  md:w-1/2 h-[64px] md:h-[160px] md:mr-2 mt-[4px] md:mt-0">
            <img
              src="https://images.staticcontent.io/rde/login/RDGIF-2.gif"
              alt="Second GIF"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResponsiveGif;